import { RouterView } from 'vue-router';
const AllClients = () => import('@/pages/clientProfile/AllLeads.vue');
const ProcessesList = () => import('@/pages/sales/leadProcess/LeadProcessesByLead.vue');
const LeadImages = () => import('@/pages/clientProfile/LeadImages.vue');
const LeadIncidences = () => import('@/pages/clientProfile/LeadIncidences.vue');
const EvaluationsList = () =>
    import('@/pages/medicalServices/evaluations/components/EvaluationsList.vue');
const CreateQuote = () => import('@/pages/sales/quotes/CreateQuote.vue');
const ClientAppointments = () =>
    import('@/pages/medicalServices/patients/components/MedicalServicesAppointments.vue');
const ClientAppointmentsCalendar = () =>
    import('@/pages/clientProfile/ClientProfileAppointmentsCalendar.vue');

const ClientQuoteCharts = () => import('@/pages/clientProfile/QuoteCharts/PatientQuoteCharts.vue');
const ClientEnvelopeTracking = () =>
    import('@/pages/clientProfile/QuoteCharts/EnvelopeTracking.vue');
const clientProfileRoutes = [
    {
        path: 'clientProfile',
        name: 'clientProfile',
        redirect: (_to) => {
            return { path: '/clientProfile/clients' };
        },
        component: RouterView,
        meta: {
            title: 'ClientProfile',
            public: false,
            icon: 'BookOpenIcon',
        },
        children: [
            {
                path: 'clients',
                name: 'ClientProfileClients',
                component: AllClients,
                meta: {
                    menu: true,
                    title: 'Leads',
                    permissionsAnyOf: ['Permissions.ClientProfile.Clients.Search'],
                },
            },
            {
                path: 'appointments-calendar',
                name: 'ClientProfileAppointmentsCalendar',
                component: ClientAppointmentsCalendar,
                meta: {
                    menu: true,
                    title: 'Appointments',
                    permissionsAnyOf: ['Permissions.ClientProfile.Appointments.Search'],
                },
            },
            {
                path: 'envelope-tracking',
                name: 'ClientProfileEnvelopeTracking',
                component: ClientEnvelopeTracking,
                meta: {
                    menu: true,
                    title: 'Envelope Tracking',
                    permissionsAnyOf: [
                        'Permissions.ClientProfile.Chart.Search',
                        'Permissions.Coordination.ClientProfileChart.Search',
                    ],
                },
            },
            {
                path: 'clients/:id/quote',
                name: 'ClientProfileQuote',
                component: CreateQuote,
                meta: {
                    title: 'Quote',
                    permissionsAnyOf: [
                        'Permissions.Sales.Quotes.Create',
                        'Permissions.Sales.Quotes.Update',
                    ],
                },
                props: (route) => ({
                    id: route.params.id,
                    routeName: 'ClientProfileClients',
                }),
            },
            {
                path: 'clients/evaluation-list/:leadId',
                name: 'ClientProfileEvaluationsList',
                component: EvaluationsList,
                meta: {
                    permissionsAnyOf: ['Permissions.MedicalServices.Evaluations.Search'],
                },
                props: (route) => ({
                    leadId: route.params.leadId,
                    fullPage: true,
                    routeName: 'ClientProfileClients',
                }),
            },
            {
                path: 'clients/processes/:leadId',
                name: 'ClientProfileProcessesList',
                component: ProcessesList,
                meta: {
                    permissionsAnyOf: ['Permissions.Sales.AssignedLeadProcesses.Detail'],
                },
                props: (route) => ({
                    leadId: route.params.leadId,
                    routeName: 'ClientProfileClients',
                }),
            },
            {
                path: 'clients/appointments/:leadId',
                name: 'ClientProfileAppointmentList',
                component: ClientAppointments,
                meta: {
                    permissionsAnyOf: ['Permissions.FrontDesk.Appointments.Search'],
                },
                props: (route) => ({
                    leadId: route.params.leadId,
                    routeName: 'ClientProfileClients',
                }),
            },
            {
                path: 'clients/images/:leadId',
                name: 'ClientProfileImagesList',
                component: LeadImages,
                meta: {
                    permissionsAnyOf: ['Permissions.ClientProfile.Clients.SearchImages'],
                },
                props: (route) => ({
                    leadId: route.params.leadId,
                    routeName: 'ClientProfileClients',
                }),
            },
            {
                path: 'clients/incidences/:leadId/:clientLeadId',
                name: 'ClientProfileIncidenceList',
                component: LeadIncidences,
                meta: {
                    permissionsAnyOf: ['Permissions.ClientProfile.Clients.SearchImages'],
                },
                props: (route) => ({
                    leadId: route.params.leadId,
                    clientLeadId: route.params.clientLeadId,
                    routeName: 'ClientProfileClients',
                }),
            },
            {
                path: 'clients/quote-charts/:leadId',
                name: 'ClientProfileQuoteCharts',
                component: ClientQuoteCharts,
                meta: {
                    permissionsAnyOf: ['Permissions.ClientProfile.Chart.Search'],
                },
                props: (route) => ({
                    leadId: route.params.leadId,
                    routeName: 'ClientProfileClients',
                }),
            },
        ],
    },
];
export default clientProfileRoutes;
